/* 
Proceso de cambio de titularidad: 
  1.un usuario solicita el cambio de titularidad dirigiendose al cliente, menu "cambio de titularidad" (SOLO HABILITADO PARA EL DEPARTAMENTO DE GRANEL o sistemas) 
  2. ver lo q hace el backend y ponerlo aca
  3. el sistema envia un mail notificando al sector administrativo que hay una revision de cambio de titularidad pendiente, y enviando un link que contiene todos los datos del cliente que son necesarios para registrarlo en sisven y tambien un casillero para el ingreso del nro de sisven del nuevo cliente.
  4. una vez que se aprueba e ingresa el nuevo sisven id del cliente, se envia un mail al solicitante del cambio de titularidad, y a lia y martina , avisando q ya ta todo ok para que le puedan cargar el pedido.
*/

import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import FormNuevoCliente from "./FormNuevoCliente";
import { enviarmails } from "../../../../../services/services";
import { UrlApi } from "../../../../../services/apirest"
import { getData } from "../../../../../services/library"
import { useNavigate } from "react-router-dom";
import { armaMailAdmin, armaMailGranel } from "./armaMail";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogoNuevoCliente(props) {
  const [dataNuevoCliente, setDataNuevoCliente] = useState({
    razon_social: "",
    direccion_fiscal: "",
    telefono1: "",
    telefono2: "",
    telefono3: "",
    mails: "",
    cuit: "",
    id_sucursal: null,
    id_localidad: null,
    id_comercial: props.cliOriginal.id_comercial,
    id_segmento: "",
    id_subsegmento: null,
    id_provincia: null,
    // id_categoria: "",
    activo: 0,
    limite_credito: 0,
    id_condicionpago: "",
    id_tipocliente: props.cliOriginal.id_tipocliente,
    unidad_fact: "",
    pesada_cliente: "",
    tipo_doc_afip: "",
    usuario: localStorage.getItem("user"),
    situacion_iva: "",
    observaciones: "",
    id_empresa: props.cliOriginal.id_empresa,
    facturacion_especial: "",
    porc_perc_iva: "",
    id_titular_anterior: props.cliOriginal.id,
    usuario_cambia_titular: localStorage.getItem("user")
  });

  const handleClose = () => {
    props.setOpen(false);
  };

  const size = "small";
  const [disableBtn, setDisableBtn] = useState(false);
  const [parametros, setParametros] = useState();

  useEffect(() => {
    getData("/cambio_titularidad_parametros", setParametros)
  }, [])

  //Manda la informacion del nuevo cliente al backend para generar un nuevo reg en la tabla clientes.
  //registra que el nuevo cliente tiene como titular anterior al original
  //registra q usuario solicita el cambio de titularidad (usuario_cambia_titular)
  //de momento el titular original queda activo y sin modificaciones hasta que se apruebe el cambio de titularidad desde el sector administrativo.
  const armar = async (e) => {
    e.preventDefault();

    const dirCorreoAdmin = parametros.filter((p) => p.parametro === "mail_administracion")[0].valor
    const dirCorreoGranel = parametros.filter((p) => p.parametro === "destinatarios_nuevasolicitud")[0].valor //En realidad no solo estan los correos de granel, sino de todos las personas/sectores q deben ser notificados acerca de una solicitud de cambio de titularidad.

    // setDisableBtn(true)
    const reqBody = {
      dataClienteOriginal: props.cliOriginal,
      dataNuevoCliente: {
        ...dataNuevoCliente,
        sisven_id: dataNuevoCliente.sisven_id || null,
        limite_credito: dataNuevoCliente.limite_credito || 0,
        porc_perc_iva: dataNuevoCliente.situacion_iva === 1 ? 1.75 : null,
        id_subsegmento: dataNuevoCliente.id_subsegmento || null,
        facturacion_especial: dataNuevoCliente.facturacion_especial || null,
        pesada_cliente: dataNuevoCliente.pesada_cliente || null,
        precio_especial: dataNuevoCliente.precio_especial || null,
        id_titular_anterior: props.cliOriginal.id,
        usuario_cambia_titular: localStorage.getItem("user"),
      },
    };

    // console.log(reqBody)
    try {
      const response = await fetch(UrlApi + "/clientes/solicitud_cambio_titularidad/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(reqBody),
      });
      const json = await response.json()
      // console.log(response)

      const { id_cliente_nuevo } = json;
      // console.log(id_cliente_nuevo || "No hay cliente nuevo")
      if (id_cliente_nuevo) {
        const url = `${parametros.filter((p) => p.parametro === "enlace_aprobar")[0].valor}/${id_cliente_nuevo}`

        const mailAdmin = armaMailAdmin(reqBody, id_cliente_nuevo, url)
        const mailGranel = armaMailGranel(reqBody, id_cliente_nuevo)

        //Es el mail que contiene el enlace y demas cosas para aprobar la solicitud de cambio de titularidad.
        enviarmails(
          dirCorreoAdmin,
          "Solicitud de cambio de titularidad", mailAdmin
        );

        //Informa que se cargo una nueva solicitud y quien la hizo.
        enviarmails(
          dirCorreoGranel,
          "Solicitud de cambio de titularidad", mailGranel
        );

        alert("Solicitud de cambio de titularidad exitosa.")
        handleClose();
      } else {
        alert("No se pudo efectuar la solicitud.")
      }
    } catch (error) {
      console.log(error)
      alert("Error al solicitar el cambio de titularidad.");
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={props.open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#1F618D" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              SOLICITUD DE CAMBIO DE TITULARIDAD - Ingreso de datos fiscales del nuevo
              titular.
            </Typography>
          </Toolbar>
        </AppBar>
        <FormNuevoCliente
          dataNuevoCliente={dataNuevoCliente}
          setDataNuevoCliente={setDataNuevoCliente}
          size={size}
          armar={armar}
          btnTxt={"cambiar titularidad"}
          disBtn={disableBtn}
        />
      </Dialog>
    </div>
  );
}

export default DialogoNuevoCliente;
